/**
 * AI.GEN lines=1-110
 * DOM/浏览器工具函数
 */

// ========== 剪贴板 ==========

/**
 * 复制文本到剪贴板
 * 优先使用 Clipboard API，如果不支持则回退到传统方法
 * @param str 要复制的文本
 */
export const copyText = async (str: string): Promise<void> => {
  // 优先使用现代的 Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(str);

      return;
    } catch (error) {
      console.warn('Clipboard API 失败，使用传统方法:', error);
    }
  }

  // 回退到传统方法
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();

  try {
    document.execCommand('copy');
  } catch (error) {
    console.error('复制失败:', error);
  } finally {
    document.body.removeChild(el);
  }
};

// ========== 下载 ==========

/**
 * 通过 a 标签下载文件
 * @param link 文件链接
 * @param fileName 文件名
 */
export function downloadByAElement(link: string, fileName: string = ''): void {
  const a = document.createElement('a');
  a.setAttribute('rel', 'noreferrer');
  a.setAttribute('href', link);
  a.setAttribute('download', fileName);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * 下载 Excel 文件
 * @param data 文件数据
 */
export function downloadXls(data: BlobPart): void {
  // 下载文件的类型：xls
  const contentType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const blob = new Blob([data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  // 以动态创建a标签进行下载
  const a = document.createElement('a');
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

// ========== 附件 ==========

/**
 * 打开附件
 * @param attachment 附件对象
 */
export const openAttachment = (attachment: { [key: string]: string }): void => {
  try {
    const attachmentUrl = Object.values(attachment)[0];

    if (!attachmentUrl) {
      return;
    }

    window.open(attachmentUrl, '_blank');
  } catch (error) {
    console.error('打开附件失败:', error);
  }
};

// ========== 历史记录 ==========

/**
 * 覆盖浏览器历史记录的 back 和 go 方法
 * 在调用 back 或 go(-1) 时触发自定义事件 'go-back'
 */
export function overrideHistoryBack(): void {
  const originalBack = history.back.bind(history);
  const originalGo = history.go.bind(history);

  history.back = function () {
    window.dispatchEvent(new CustomEvent('go-back'));
    originalBack();
  };

  history.go = function (delta: number) {
    if (delta === -1) {
      window.dispatchEvent(new CustomEvent('go-back'));
    }

    originalGo(delta);
  };
}
